import styled from "styled-components";

export const TestingBasicLabel = styled.label`
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 6rem;
    position: relative;
    gap: 4rem;

    ${({ isDisabled }) => isDisabled && `
        cursor: not-allowed;
        
        &.checkbox {
            opacity: .6;
        }
    `}
`;